import theme from '../../../../js/shared/new-theme';

export const defaultStyle = `
    color: ${theme.palette.gray[600].value};
    
    .rotate-left {
        transform: rotate(90deg);
        display: inline-block;
        color: ${theme.palette.gray[600].value};
    }
`;
